/* maker-bundle.js — consolidated theme/header inline scripts. Built 2026-05-21. */
/* Each block runs at <script defer> execution time (after HTML parse, before DOMContentLoaded). */

/* === theme.liquid block [0] === */
(function () {
        if (document.body && !document.body.classList.contains('template-product')) {
          // Will run on all pages; skip cleanup if not product
        }
        function clean() {
          var scopes = document.querySelectorAll('.vb-pdp-tabs, .vb-pdp-tab-content, .product-copy, [id^="cr-"], [id^="crx-"], .vb-collection-descr-body, .crx-scope');
          scopes.forEach(function (scope) {
            scope.querySelectorAll('style').forEach(function (s) { s.remove(); });
            scope.querySelectorAll('meta').forEach(function (m) { m.remove(); });
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', clean);
        } else {
          clean();
        }
        // Re-run after delay in case async content
        setTimeout(clean, 500);
      })();

/* === theme.liquid block [1] === */
if (Shopify.designMode) {
        document.documentElement.classList.add('shopify-design-mode');
      }

/* === theme.liquid block [2] === */
// === Legacy faq-list <ul><li> transformer ===
      // Older collection descriptions use:
      //   <section class="section faq"><h3>FAQ</h3>
      //     <ul class="faq-list">
      //       <li><span class="faq-q">Q</span><div class="faq-a">A</div></li> ...
      //     </ul>
      //   </section>
      // Convert each <li> with .faq-q + .faq-a into a <details><summary>Q</summary><p>A</p></details>,
      // and swap the parent <ul.faq-list> for a <div class="faq-list"> so global FAQ CSS hits it.
      (function () {
        function transformLegacyFaqLists() {
          var uls = document.querySelectorAll('ul.faq-list');
          uls.forEach(function (ul) {
            if (ul.dataset.makerFaqLegacy === '1') return;
            var items = Array.prototype.slice.call(ul.querySelectorAll(':scope > li'));
            var anyMatch = items.some(function (li) {
              return li.querySelector(':scope > .faq-q');
            });
            if (!anyMatch) return;
            ul.dataset.makerFaqLegacy = '1';
            var div = document.createElement('div');
            div.className = 'faq-list maker-faq-legacy';
            items.forEach(function (li) {
              var qEl = li.querySelector(':scope > .faq-q');
              var aEl = li.querySelector(':scope > .faq-a');
              var qHtml = qEl ? qEl.innerHTML.trim() : '';
              var aHtml = aEl ? aEl.innerHTML.trim() : '';
              var details = document.createElement('details');
              var summary = document.createElement('summary');
              summary.innerHTML = qHtml;
              var body = document.createElement('p');
              body.innerHTML = aHtml || '<em>—</em>';
              details.appendChild(summary);
              details.appendChild(body);
              div.appendChild(details);
            });
            ul.replaceWith(div);
          });
          // Strip the outer <section class="section faq"> card chrome so only
          // individual <details> elements show as cards.
          document.querySelectorAll('section.section.faq, section.faq.section').forEach(function (s) {
            s.classList.add('maker-faq-flat');
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', transformLegacyFaqLists);
        } else {
          transformLegacyFaqLists();
        }
        setTimeout(transformLegacyFaqLists, 120);
        setTimeout(transformLegacyFaqLists, 700);
      })();

      // === FAQ wrapper unwrapper ===
      // Some product descriptions wrap the entire FAQ list inside a single
      // <details><summary>FAQ</summary>...</details>, causing the whole block
      // to render as one collapsed "FAQ+" row that nests the individual
      // questions. We unwrap any such outer <details> so the inner FAQs
      // render flat at the top level.
      (function () {
        function unwrapFaqWrappers() {
          var scopes = document.querySelectorAll(
            '.vb-readme details, .product-copy details, .crx-scope details, ' +
            '.vb-collection-descr-body details, .rte details, .faq-list details'
          );
          scopes.forEach(function (d) {
            if (d.dataset.makerFaqUnwrapped === '1') return;
            var sum = d.querySelector(':scope > summary');
            if (!sum) return;
            var label = sum.textContent.trim();
            var isFaqLabel = /^faqs?(\b|[\s—\-–:])/i.test(label);
            if (!isFaqLabel) return;
            // Must contain nested FAQ structure to qualify as a wrapper.
            var nested = d.querySelector(':scope > .faq-list, :scope > details, :scope > div .faq, :scope > .faq, :scope > div details, :scope .faq-list, :scope details');
            if (!nested) return;
            d.dataset.makerFaqUnwrapped = '1';
            var parent = d.parentNode;
            // Insert a heading from the summary so context isn't lost.
            var h3 = document.createElement('h3');
            h3.className = 'vb-faq-heading';
            h3.textContent = label;
            parent.insertBefore(h3, d);
            // Move remaining children (everything except summary) out.
            Array.prototype.slice.call(d.childNodes).forEach(function (n) {
              if (n === sum) return;
              parent.insertBefore(n, d);
            });
            d.remove();
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', unwrapFaqWrappers);
        } else {
          unwrapFaqWrappers();
        }
        setTimeout(unwrapFaqWrappers, 150);
        setTimeout(unwrapFaqWrappers, 800);
      })();

      // === FAQ transformer ===
      // Walks every .faq-list .faq (including those rendered inside product
      // descriptions) and converts the static <div class="faq"><strong>Q</strong>A</div>
      // into a collapsible <details class="faq vb-faq"><summary>Q</summary>A</details>.
      // Default state = closed. Idempotent (skips already-transformed entries).
      (function () {
        function transformFaqs() {
          document.querySelectorAll('.faq-list .faq, .product-copy .faq, .vb-faq-list .faq, .crx-scope .faq, .vb-readme .faq, .vb-collection-descr-body .faq, .rte .faq').forEach(function (faq) {
            if (faq.tagName === 'DETAILS') return;
            if (faq.dataset.makerFaqTransformed === '1') return;
            faq.dataset.makerFaqTransformed = '1';
            var q = faq.querySelector('strong, b');
            var question = '';
            var answer = '';
            if (q) {
              question = q.textContent.trim();
              var clone = faq.cloneNode(true);
              var s = clone.querySelector('strong, b');
              if (s) s.remove();
              answer = clone.innerHTML.trim();
            } else {
              // No <strong>: take first line as question, rest as answer.
              var html = faq.innerHTML.trim();
              var parts = html.split(/<br\s*\/?>|\n/);
              question = (parts[0] || '').replace(/<[^>]+>/g, '').trim();
              answer = parts.slice(1).join('<br>').trim();
              if (!answer) answer = '';
            }
            // Strip leading "Q:" / "Q." that some products use; we add our own.
            question = question.replace(/^Q\s*[:\.]\s*/i, '');
            var details = document.createElement('details');
            details.className = 'faq vb-faq';
            var summary = document.createElement('summary');
            summary.className = 'vb-faq-q';
            summary.textContent = question;
            var ans = document.createElement('div');
            ans.className = 'vb-faq-a';
            ans.innerHTML = answer || '<em>—</em>';
            details.appendChild(summary);
            details.appendChild(ans);
            faq.replaceWith(details);
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', transformFaqs);
        } else {
          transformFaqs();
        }
        // Re-run after dynamic content (recommendations, AJAX renders, etc.)
        setTimeout(transformFaqs, 200);
        setTimeout(transformFaqs, 1000);
      })();

      // === Global stray cart-count-bubble defender ===
      // Runs on every page (not just PDP). Walks the DOM, removes any
      // .cart-count-bubble or shopify-section--cart-icon-bubble that's
      // not inside the allowed contexts. Re-runs on every DOM mutation
      // so AJAX cart updates can't reintroduce the stray digit.
      (function () {
        function purge() {
          var nodes = document.querySelectorAll(
            '.cart-count-bubble, .shopify-section--cart-icon-bubble, [id^="shopify-section-cart-icon-bubble"]'
          );
          nodes.forEach(function (el) {
            if (!el.closest('.maker-prop') && !el.closest('#cart-icon-bubble') && !el.closest('.shopify-section-header-group') && !el.closest('header.header')) {
              el.remove();
            }
          });
          // Also strip orphan digit-only spans living as direct children of main / vb-* wrappers.
          var roots = document.querySelectorAll('main#MainContent, .vb-pdp, .vb-pdp-left, .vb-product-section, .vb-root, .vb-section-inner, .vb-hero, body');
          roots.forEach(function (r) {
            Array.prototype.slice.call(r.children).forEach(function (c) {
              if (c.tagName === 'SPAN' && !c.className && !c.id && /^\s*\d+\s*$/.test(c.textContent)) c.remove();
            });
            Array.prototype.slice.call(r.childNodes).forEach(function (n) {
              if (n.nodeType === 3 && /^\s*\d+\s*$/.test(n.textContent)) n.remove();
            });
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', purge);
        } else {
          purge();
        }
        setTimeout(purge, 100);
        setTimeout(purge, 500);
        setTimeout(purge, 1500);
        if (window.MutationObserver) {
          new MutationObserver(purge).observe(document.body, { childList: true, subtree: true });
        }
      })();

/* === theme.liquid block [4] === */
(function () {
        var sh = document.querySelector('sticky-header, .header-wrapper');
        if (!sh) return;
        function update() {
          var h = sh.offsetHeight;
          if (h > 0) document.documentElement.style.setProperty('--header-height', h + 'px');
        }
        update();
        if (window.ResizeObserver) {
          try { new ResizeObserver(update).observe(sh); } catch (e) {}
        }
        window.addEventListener('load', update);
        window.addEventListener('resize', update, { passive: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
      })();

/* === theme.liquid block [5] === */
(function () {
        function bindFilterToggle() {
          var filters = document.querySelector('.vb-filters');
          if (!filters || filters.dataset.toggleBound === '1') return;
          filters.dataset.toggleBound = '1';
          // Tap on the ::before pseudo (or anywhere in the filters wrapper top edge) toggles
          filters.addEventListener('click', function (e) {
            // Only fire if click is in top-bar area (where ::before label sits) on mobile
            if (window.innerWidth > 900) return;
            var rect = filters.getBoundingClientRect();
            var clickY = e.clientY - rect.top;
            // Top 48px is the label area (matches CSS padding 14px + line-height ~20)
            if (clickY <= 48 || e.target === filters) {
              var open = filters.getAttribute('data-open') === 'true';
              filters.setAttribute('data-open', String(!open));
            }
          });
          // Auto-close when desktop resize
          window.addEventListener('resize', function () {
            if (window.innerWidth > 900) filters.removeAttribute('data-open');
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', bindFilterToggle);
        } else {
          bindFilterToggle();
        }
      })();

/* === theme.liquid block [6] === */
(function () {
        function findCart() {
          return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }
        document.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest && e.target.closest('[data-vb-add-to-cart]');
          if (!btn || btn.disabled) return;
          e.preventDefault();
          var vid = btn.getAttribute('data-vb-variant-id');
          if (!vid) return;
          btn.disabled = true;
          var originalText = btn.textContent;
          btn.textContent = '…';
          var cart = findCart();
          var formData = new FormData();
          formData.append('id', vid);
          formData.append('quantity', '1');
          if (cart && cart.getSectionsToRender) {
            try {
              formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
              formData.append('sections_url', window.location.pathname);
            } catch (err) {}
          }
          var ADD_URL = window.routes && window.routes.cart_add_url || '/cart/add.js';
          function tryAdd(payload, isRetry) {
            return fetch(ADD_URL, {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
              body: payload
            })
              .then(function (r) {
                if (!r.ok && !isRetry && r.status >= 400) {
                  var bare = new FormData();
                  bare.append('id', vid);
                  bare.append('quantity', '1');
                  return tryAdd(bare, true);
                }
                return r.json();
              })
              .then(function (data) {
                if (!data) return;
                if (data.status) {
                  // Common cause: stock < 1 OR already at max in cart
                  var msg = 'fail';
                  if (data.description && /already|maximum|stock|cannot/i.test(data.description)) msg = 'in cart';
                  btn.textContent = msg;
                  setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
                  return;
                }
                if (cart && cart.renderContents && data.sections) cart.renderContents(data);
                if (window.makerSyncCartCount) window.makerSyncCartCount();
                if (window.publish && window.PUB_SUB_EVENTS) {
                  try {
                    window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                      source: 'vb-card-add', productVariantId: vid, cartData: data
                    });
                  } catch (err) {}
                }
                btn.textContent = '✓';
                setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1200);
              })
              .catch(function () {
                if (!isRetry) {
                  var bare = new FormData();
                  bare.append('id', vid);
                  bare.append('quantity', '1');
                  return tryAdd(bare, true);
                }
                btn.textContent = 'err';
                setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
              });
          }
          tryAdd(formData, false);
        });
      })();

/* === cart count live sync — added 2026-05-23 === */
(function () {
  var syncing = false;
  function syncCartCount() {
    if (syncing) return;
    syncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var count = c.item_count || 0;
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          var span = b.querySelector('span[aria-hidden]') || b;
          span.textContent = count;
        });
        // maker-prop top strip cart pill: "cart[N]" form
        document.querySelectorAll('.maker-prop-actions a.cart .cart-count-bubble').forEach(function (b) {
          b.textContent = count;
        });
      })
      .catch(function(){})
      .finally(function () { syncing = false; });
  }
  // Expose globally for explicit calls
  window.makerSyncCartCount = syncCartCount;
  // Subscribe to Shopify's cartUpdate pubsub
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, syncCartCount); } catch(e){}
  }
  // Also subscribe via window event when pubsub not yet ready
  document.addEventListener('cart:updated', syncCartCount);
  // Intercept fetch to /cart/{add,change,update,clear}.js — auto-sync after
  var origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var p = origFetch.apply(this, arguments);
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) {
      p.then(function () { setTimeout(syncCartCount, 50); }).catch(function(){});
    }
    return p;
  };
})();

/* === theme.liquid block [7] === */
(function () {
        function wrapWideTables() {
          var SCOPES = '.crx-scope, .vb-readme, .product-copy, .vb-collection-descr-body, .rte';
          var tables = document.querySelectorAll(SCOPES + ' table');
          tables.forEach(function (t) {
            if (t.parentElement && t.parentElement.classList.contains('vb-table-scroll')) return;
            var wrap = document.createElement('div');
            wrap.className = 'vb-table-scroll';
            wrap.style.cssText = 'overflow-x:auto;-webkit-overflow-scrolling:touch;max-width:100%;margin:1em 0;';
            t.parentNode.insertBefore(wrap, t);
            wrap.appendChild(t);
            var headers = Array.prototype.slice.call(t.querySelectorAll('thead th'))
                          .map(function (th) { return th.textContent.trim(); });
            if (headers.length) {
              t.querySelectorAll('tbody tr').forEach(function (tr) {
                tr.querySelectorAll('td').forEach(function (td, i) {
                  if (headers[i] && !td.hasAttribute('data-label')) {
                    td.setAttribute('data-label', headers[i]);
                  }
                });
              });
            }
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', wrapWideTables);
        } else {
          wrapWideTables();
        }
        // Re-run after AJAX section refreshes (variant change, infinite scroll, etc.)
        if (window.MutationObserver) {
          new MutationObserver(function (m) {
            for (var i = 0; i < m.length; i++) {
              if (m[i].addedNodes.length) { wrapWideTables(); break; }
            }
          }).observe(document.body, { childList: true, subtree: true });
        }
      })();

/* === theme.liquid block [8] === */
// Inject featured.md ribbon (bypass section cache)
      (function() {
        function injectRibbon() {
          var card = document.querySelector('.vb-featured-card');
          if (!card) return;
          if (card.querySelector('.vb-featured-ribbon')) return;
          var pos = window.getComputedStyle(card).position;
          if (pos === 'static') card.style.position = 'relative';
          var r = document.createElement('div');
          r.className = 'vb-featured-ribbon';
          r.textContent = 'featured.md';
          r.style.cssText = 'position:absolute;top:12px;left:16px;background:#5cb030;color:#1a1a1a;padding:3px 10px;font-family:JetBrains Mono,SF Mono,Menlo,Consolas,monospace;font-size:11px;font-weight:700;letter-spacing:0.04em;z-index:2;display:inline-block;';
          card.insertBefore(r, card.firstChild);
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', injectRibbon);
        } else {
          injectRibbon();
        }
        // Also re-inject after JSONP load
        setTimeout(injectRibbon, 1500);
      })();

/* === header.liquid block [0] === */
(function () {
  // maker direction — open cat-strip dropdowns on hover + position dropdowns via fixed coords
  // Using position:fixed so the panel escapes ALL stacking contexts on the page.
  // ALSO: stamp inline styles on the panel + every child link to win against
  // Dawn's `.gradient`, `.global-settings-popup`, `.link--text`, `.header__menu-item`
  // cascade (which sets color via --color-foreground = white in the header context).
  function stampStyles(panel) {
    // Panel itself — pure white card, black text, sharp shadow.
    panel.style.cssText += ';' + [
      'background:#ffffff',
      'background-color:#ffffff',
      'background-image:none',
      'border:1px solid #1a1a1a',
      'border-radius:8px',
      'box-shadow:0 8px 28px rgba(0,0,0,0.28)',
      'padding:6px',
      'min-width:240px',
      'z-index:2147483647',
      'color:#000000',
      'font-family:"JetBrains Mono","SF Mono",Menlo,Consolas,monospace'
    ].join(' !important;') + ' !important;';
    // Every link/li inside — black text on white, green pill on hover.
    panel.querySelectorAll('a, .header__menu-item, .list-menu__item--link').forEach(function (a, i) {
      a.style.cssText += ';' + [
        'background:transparent',
        'background-color:transparent',
        'background-image:none',
        'color:' + (i === 0 ? '#4a8f24' : '#000000'),
        'font-family:"JetBrains Mono","SF Mono",Menlo,Consolas,monospace',
        'font-size:13px',
        'font-weight:' + (i === 0 ? '800' : '600'),
        'text-transform:none',
        'letter-spacing:0',
        'text-decoration:none',
        'padding:9px 14px',
        'border:0',
        'border-radius:4px',
        'display:flex',
        'justify-content:space-between',
        'align-items:center',
        'white-space:nowrap',
        'text-shadow:none',
        'opacity:1'
      ].join(' !important;') + ' !important;';
      // Force every span/text node child to inherit the right color too.
      a.querySelectorAll('span').forEach(function (s) {
        s.style.cssText += ';color:' + (i === 0 ? '#4a8f24' : '#000000') + ' !important;background:transparent !important;text-shadow:none !important;opacity:1 !important;';
      });
      // Hover handlers — green pill, white text.
      if (!a.dataset.makerHoverBound) {
        a.dataset.makerHoverBound = '1';
        a.addEventListener('mouseenter', function () {
          a.style.setProperty('background', i === 0 ? '#4a8f24' : '#5cb030', 'important');
          a.style.setProperty('color', '#ffffff', 'important');
          a.querySelectorAll('span').forEach(function (s) { s.style.setProperty('color', '#ffffff', 'important'); });
        });
        a.addEventListener('mouseleave', function () {
          a.style.setProperty('background', 'transparent', 'important');
          a.style.setProperty('color', i === 0 ? '#4a8f24' : '#000000', 'important');
          a.querySelectorAll('span').forEach(function (s) { s.style.setProperty('color', i === 0 ? '#4a8f24' : '#000000', 'important'); });
        });
      }
    });
    // The first item gets a dashed separator below.
    var firstA = panel.querySelector('li:first-child a, li:first-child .header__menu-item');
    if (firstA) {
      firstA.style.setProperty('border-bottom', '1px dashed rgba(0,0,0,0.18)', 'important');
      firstA.style.setProperty('border-radius', '0', 'important');
      firstA.style.setProperty('padding-bottom', '11px', 'important');
      firstA.style.setProperty('margin-bottom', '4px', 'important');
    }
  }

  function positionPanel(menu) {
    var d = menu.querySelector('details'); if (!d) return;
    var panel = d.querySelector('.header__submenu'); if (!panel) return;
    // Anchor to the <li> the menu is inside. li wraps the trigger, gives
    // us the actual visual position regardless of summary padding.
    var li = menu.closest('li') || d.parentElement || menu;
    var rect = li.getBoundingClientRect();
    panel.style.setProperty('position', 'fixed', 'important');
    panel.style.setProperty('top', (rect.bottom) + 'px', 'important');
    panel.style.setProperty('left', Math.max(8, Math.min(rect.left, window.innerWidth - 240)) + 'px', 'important');
    panel.style.setProperty('right', 'auto', 'important');
    panel.style.setProperty('bottom', 'auto', 'important');
    panel.style.setProperty('transform', 'none', 'important');
    panel.style.setProperty('margin', '0', 'important');
    stampStyles(panel);
  }
  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    var hoverEnabled = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    menus.forEach(function (m) {
      var d = m.querySelector('details'); if (!d) return; var t;
      // Position on open
      d.addEventListener('toggle', function () { if (d.open) positionPanel(m); });
      // Hover open on desktop
      if (hoverEnabled) {
        m.addEventListener('mouseenter', function () {
          clearTimeout(t); d.setAttribute('open', ''); positionPanel(m);
        });
        m.addEventListener('mouseleave', function () {
          t = setTimeout(function () { d.removeAttribute('open'); }, 150);
        });
      }
      // Reposition on scroll/resize
      window.addEventListener('scroll', function () { if (d.open) positionPanel(m); }, { passive: true });
      window.addEventListener('resize', function () { if (d.open) positionPanel(m); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
